<cm-input-container [hideBorder]="true">
    <ng-container cm-inline-label> json </ng-container>
    <ng-container cm-input
        ><input
            name="jsonValue"
            matInput
            [ngModel]="$editString()"
            (ngModelChange)="setEditString($event)"
            class="cm-input"
            [ngModelOptions]="{standalone: true}"
            [class.cm-invalid]="!$editValid()"
            (focus)="onFocus()"
            (blur)="onBlur()"
    /></ng-container>
</cm-input-container>
@if ($editSingleParams()) {
    @for (entry of $objectEntries(); track entry.key) {
        @switch (typeof entry.value) {
            @case ("boolean") {
                <cm-input-container [hideBorder]="true">
                    <ng-container cm-inline-label> {{ entry.key }} </ng-container>
                    <cm-toggle [toggle]="entry.value" (toggleChange)="updateEntry(entry.key, $event)"> </cm-toggle>
                </cm-input-container>
            }
            @case ("number") {
                <cm-input-container [hideBorder]="true">
                    <ng-container cm-inline-label> {{ entry.key }} </ng-container>
                    <ng-container cm-input>
                        <cm-numeric-input
                            [value]="entry.value"
                            [decimalPlaces]="$decimalPlaces()"
                            [emptyValue]="0"
                            [placeholder]=""
                            (valueChange)="updateEntry(entry.key, $event)"
                        >
                        </cm-numeric-input>
                    </ng-container>
                </cm-input-container>
            }
            @case ("string") {
                <cm-input-container [hideBorder]="true">
                    <ng-container cm-inline-label> {{ entry.key }} </ng-container>
                    <ng-container cm-input>
                        <cm-string-input [value]="entry.value" (valueChange)="updateEntry(entry.key, $event)"> </cm-string-input>
                    </ng-container>
                </cm-input-container>
            }
            @case ("object") {
                <cm-input-container [hideBorder]="true">
                    <ng-container cm-inline-label> {{ entry.key }} </ng-container>
                    <ng-container cm-input>
                        <cm-json-input [value]="entry.value" (valueChange)="updateEntry(entry.key, $event)" [decimalPlaces]="$decimalPlaces()"></cm-json-input>
                    </ng-container>
                </cm-input-container>
            }
        }
    }
}
